import { defineComponent as _defineComponent } from 'vue'
import MapMarker from '@/components/core/map/MapMarker.vue'

export type MapDefaultMarkerEvents = {
  (e: 'click', event: google.maps.MapMouseEvent): void
  (e: 'drag', event: google.maps.MapMouseEvent): void
  (e: 'dragend', event: google.maps.MapMouseEvent): void
  (e: 'dragstart'): void
  (e: 'gmp-click'): google.maps.marker.AdvancedMarkerClickEvent // only available with v=beta
}

export interface MapDefaultMarkerProps {
  options: google.maps.marker.AdvancedMarkerElementOptions
  hide?: boolean
  label?: string
  imageSrc?: string
}


export default /*#__PURE__*/_defineComponent({
  __name: 'MapDefaultMarker',
  props: {
    options: null,
    hide: { type: Boolean },
    label: null,
    imageSrc: null
  },
  emits: ["click", "drag", "dragend", "dragstart", "gmp-click"],
  setup(__props: any) {




return { __sfc: true,MapMarker }
}

})